import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0.5C4.98 0.5 0.5 2.74 0.5 5.5C0.5 7.74 3.44 9.63 7.5 10.27V13.5L11.5 9.5L7.5 5.5V8.23C4.35 7.67 2.5 6.33 2.5 5.5C2.5 4.44 5.54 2.5 10.5 2.5C15.46 2.5 18.5 4.44 18.5 5.5C18.5 6.23 17.04 7.39 14.5 8.03V10.08C18.03 9.31 20.5 7.55 20.5 5.5C20.5 2.74 16.02 0.5 10.5 0.5Z"
}), 'ReturnCircle', {
  viewBox: '0 0 25 25'
});